import { call, put, select, takeLatest, delay } from 'redux-saga/effects';

import {
	getSubscriptions,
	getSubscriptionsSuccess,
	getSubscriptionsFailure,
	createSubscription,
	createSubscriptionSuccess,
	createSubscriptionFailure,
	getSubscriptionsStatuses,
	getSubscriptionsStatusesSuccess,
	getSubscriptionsStatusesFailure,
	getSubscriptionById,
	getSubscriptionByIdSuccess,
	getSubscriptionByIdFailure,
	getInvoices,
	getInvoicesSuccess,
	getInvoicesFailure,
	activateSubscription,
	activateSubscriptionFailure,
	activateSubscriptionSuccess,
	suspendSubscription,
	suspendSubscriptionFailure,
	suspendSubscriptionSuccess,
	payInvoiceExternally,
	payInvoiceExternallyFailure,
	payInvoiceExternallySuccess,
	getSubscriptionProviderinfo,
	getSubscriptionProviderinfoFailure,
	getSubscriptionProviderinfoSuccess,
	getSubscriptionByClientId,
	getSubscriptionByClientIdFailure,
	getSubscriptionByClientIdSuccess,
	resetSubscriptionByClientId,
	updateSubscriptionIUGU,
	updateSubscriptionIUGUFailure,
	updateSubscriptionIUGUSuccess,
	changePlanSubscriptionByIUGU,
	changePlanSubscriptionByIUGUFailure,
	changePlanSubscriptionByIUGUSuccess,
} from '.';

import subscriptionService from '../../../services/SubscriptionService';

function* rootSaga() {
	yield takeLatest(getSubscriptions, getSubscriptionsSaga);
	yield takeLatest(createSubscription, createSubscriptionSaga);
	yield takeLatest(getSubscriptionsStatuses, getSubscriptionsStatusesSaga);
	yield takeLatest(getSubscriptionById, getSubscriptionByIdSaga);
	yield takeLatest(getInvoices, getInvoicesSaga);
	yield takeLatest(activateSubscription, activateSubscriptionSaga);
	yield takeLatest(suspendSubscription, suspendSubscriptionSaga);
	yield takeLatest(payInvoiceExternally, payInvoiceExternallySaga);
	yield takeLatest(getSubscriptionProviderinfo, getSubscriptionProviderinfoSaga);
	yield takeLatest(getSubscriptionByClientId, getSubscriptionByClientIdSaga);
	yield takeLatest(updateSubscriptionIUGU, updateSubscriptionPaymentMethodIUGUSaga);
	yield takeLatest(changePlanSubscriptionByIUGU, changePlanSubscriptionByIUGUSaga);
}

function* updateSubscriptionPaymentMethodIUGUSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(subscriptionService.updatePaymentMehotdSubscriptionIUGU, payload);
		yield put(updateSubscriptionIUGUSuccess(response));
	} catch (error) {
		yield put(updateSubscriptionIUGUFailure(error));
	}
}

function* changePlanSubscriptionByIUGUSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(subscriptionService.updatePlanSubscriptionIUGU, payload);
		yield put(changePlanSubscriptionByIUGUSuccess(response));
	} catch (error) {
		yield put(changePlanSubscriptionByIUGUFailure(error));
	}
}

function* getSubscriptionsSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(subscriptionService.getAll, payload);
		yield put(getSubscriptionsSuccess(response));
	} catch (error) {
		yield put(getSubscriptionsFailure(error));
	}
}

function* createSubscriptionSaga({ payload }) {
	try {
		yield delay(300);
		const createdSubscription = yield call(subscriptionService.create, payload);
		yield put(createSubscriptionSuccess(createdSubscription));
	} catch (error) {
		yield put(createSubscriptionFailure(error));
	}
}

function* getSubscriptionsStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(subscriptionService.getStatuses);
		yield put(getSubscriptionsStatusesSuccess(response));
	} catch (error) {
		yield put(getSubscriptionsStatusesFailure(error));
	}
}

function* getSubscriptionByIdSaga({ payload }) {
	const subscriptionId = payload;
	try {
		yield delay(300);
		const response = yield call(subscriptionService.getById, subscriptionId);
		yield put(getSubscriptionByIdSuccess(response));
	} catch (error) {
		yield put(getSubscriptionByIdFailure(error));
	}
}

function* getInvoicesSaga({ payload }) {
	const { clientId, subscriptionId, ...rest } = payload;
	try {
		yield delay(300);
		const response = yield call(subscriptionService.getInvoices, clientId, rest, subscriptionId);
		yield put(getInvoicesSuccess(response));
	} catch (error) {
		yield put(getInvoicesFailure(error));
	}
}

function* activateSubscriptionSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const response = yield call(subscriptionService.activate, id);
		yield put(activateSubscriptionSuccess(response));

		// Reload subscriptions data:
		const tableParams = yield select(
			({ subscriptions }) => subscriptions.subscriptions.tableParams,
		);
		yield put(getSubscriptions({ ...tableParams }));

		// Reload subscription details:
		const { id: selectedSubscriptionId } = yield select(
			({ subscriptions }) => subscriptions.subscription.data,
		);
		if (id == selectedSubscriptionId) {
			//yield put(getSubscriptionById(id));
			yield put(getSubscriptionByIdSuccess(response));
		}
	} catch (error) {
		yield put(activateSubscriptionFailure(error));
	}
}

function* suspendSubscriptionSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const response = yield call(subscriptionService.suspend, id);
		yield put(suspendSubscriptionSuccess(response));

		// Reload subscriptions data:
		const tableParams = yield select(
			({ subscriptions }) => subscriptions.subscriptions.tableParams,
		);
		yield put(getSubscriptions({ ...tableParams }));

		// Reload subscription details:
		const { id: selectedSubscriptionId } = yield select(
			({ subscriptions }) => subscriptions.subscription.data,
		);
		if (id == selectedSubscriptionId) {
			//yield put(getSubscriptionById(id));
			yield put(getSubscriptionByIdSuccess(response));
		}
	} catch (error) {
		yield put(suspendSubscriptionFailure(error));
	}
}

function* payInvoiceExternallySaga({ payload }) {
	const { subscriptionId, invoiceId, externalPaymentId, externalPaymentDescription, isPurchase } =
		payload;
	try {
		yield delay(300);
		const response = yield call(
			subscriptionService.payInvoiceExternally,
			subscriptionId,
			invoiceId,
			externalPaymentId,
			externalPaymentDescription,
			isPurchase,
		);
		yield put(payInvoiceExternallySuccess(response));

		// Reload subscription details:
		const selectedSubscription = yield select(
			({ subscriptions }) => subscriptions.subscription.data,
		);
		if (selectedSubscription) {
			yield call(getInvoicesSaga, { payload: { clientId: selectedSubscription.clientId } });
			if (subscriptionId == selectedSubscription.id) {
				yield call(getSubscriptionByIdSaga, { payload: subscriptionId });
			}
		}
	} catch (error) {
		// Extract error message - the service should already throw a string, but handle edge cases
		const errorMessage =
			typeof error === 'string'
				? error
				: error?.response?.data?.error ||
				error?.response?.data?.message ||
				error?.message ||
				'Erro ao pagar fatura. Tente novamente mais tarde.';
		yield put(payInvoiceExternallyFailure(errorMessage));
	}
}

function* getSubscriptionProviderinfoSaga({ payload }) {
	const subscriptionId = payload;
	try {
		yield delay(300);
		const response = yield call(subscriptionService.getProviderinfo, subscriptionId);
		yield put(getSubscriptionProviderinfoSuccess(response));
	} catch (error) {
		yield put(getSubscriptionProviderinfoFailure(error));
	}
}

function* getSubscriptionByClientIdSaga({ payload }) {
	const clientId = payload;
	try {
		yield delay(300);
		yield put(resetSubscriptionByClientId());
		const response = yield call(subscriptionService.getSubscriptionByClientId, clientId);
		yield put(getSubscriptionByClientIdSuccess(response));
	} catch (error) {
		yield put(getSubscriptionByClientIdFailure(error));
	}
}

export default rootSaga;
